module.exports = __webpack_public_path__ + "static/media/err403.2dda86ad.svg";